import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const TestimonialsPage = lazy(() => import('./TestimonialsPage'));

const TestimonialsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Testimonials,
  routes: [
    {
      path: 'testimonials',
      element: <TestimonialsPage />,
    },
  ],
};

export default TestimonialsConfig;
